<template>
  <div>
    <v-form @submit.prevent="submit">
      <v-textarea
        v-model="options.availability_preferences"
        :label="$gettext('Preferenze disponibilità')"
      ></v-textarea>
      <p v-translate>
        Per inviare proposte di programma scrivi a info@oficinaocm.com
      </p>
      <v-row>
        <v-col v-if="options.show__is_festival" cols="12" sm="6">
          <v-dialog v-model="dialog0" width="800">
            <template v-slot:activator="{ on }">
              <v-btn depressed small outlined v-on="on">
                {{ $gettext("Leggi i termini prestazione artistica") }}
              </v-btn>
            </template>

            <v-card>
              <v-card-title v-translate>
                Dichiarazione di prestazione artistica gratuita
              </v-card-title>

              <v-card-text
                v-html="
                  $language.current == 'en'
                    ? options.terms_performance_en
                    : options.terms_performance
                "
              ></v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  v-translate
                  color="primary"
                  text
                  @click="dialog0 = false"
                >
                  Chiudi
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-checkbox
            v-model="options.accepted_terms_performance"
            class="mb-6"
            :disabled="withData.accepted_terms_performance"
            :label="$gettext('Accettato i termini prestazione artistica')"
            :messages="[
              dateIfAccepted(
                withData.accepted_terms_performance,
                withData.accepted_terms_performance_date
              ),
            ]"
          ></v-checkbox>
        </v-col>

        <v-col v-if="options.show__is_festival" cols="12" sm="6">
          <v-dialog v-model="dialog1" width="800">
            <template v-slot:activator="{ on }">
              <v-btn depressed small outlined v-on="on">
                {{ $gettext("Leggi i termini accoglienza") }}
              </v-btn>
            </template>

            <v-card>
              <v-card-text
                v-html="
                  $language.current == 'en'
                    ? options.terms_hospitality_en
                    : options.terms_hospitality
                "
              ></v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  v-translate
                  color="primary"
                  text
                  @click="dialog1 = false"
                >
                  Chiudi
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-checkbox
            v-model="options.accepted_terms_hospitality"
            class="mb-6"
            :disabled="withData.accepted_terms_hospitality"
            :label="$gettext('Accettato i termini accoglienza')"
            :messages="[
              dateIfAccepted(
                withData.accepted_terms_hospitality,
                withData.accepted_terms_hospitality_date
              ),
            ]"
          ></v-checkbox>
        </v-col>

        <v-col cols="12" sm="6">
          <v-dialog v-model="dialog2" width="800">
            <template v-slot:activator="{ on }">
              <v-btn depressed small outlined v-on="on">
                {{ $gettext("Leggi i termini privacy") }}
              </v-btn>
            </template>

            <v-card>
              <v-card-title v-translate>
                Informativa e consenso al trattamento dati Associazione
                Orchestra da Camera Mantova
              </v-card-title>

              <v-card-text
                v-html="
                  $language.current == 'en'
                    ? options.terms_privacy_en
                    : options.terms_privacy
                "
              ></v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  v-translate
                  color="primary"
                  text
                  @click="dialog2 = false"
                >
                  Chiudi
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-checkbox
            v-model="options.accepted_terms_privacy"
            class="mb-6"
            :disabled="withData.accepted_terms_privacy"
            :label="$gettext('Accettato i termini privacy')"
            :messages="[
              dateIfAccepted(
                withData.accepted_terms_privacy,
                withData.accepted_terms_privacy_date
              ),
            ]"
          ></v-checkbox>
        </v-col>

        <v-col cols="12" sm="4">
          <v-dialog v-model="dialog3" width="800">
            <template v-slot:activator="{ on }">
              <v-btn depressed small outlined v-on="on">
                {{ $gettext("Leggi i termini foto/video") }}
              </v-btn>
            </template>

            <v-card>
              <v-card-title v-translate>
                Liberatoria per fotografie e riprese audio/video
              </v-card-title>

              <v-card-text
                v-html="
                  $language.current == 'en'
                    ? options.terms_media_en
                    : options.terms_media
                "
              ></v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  v-translate
                  color="primary"
                  text
                  @click="dialog3 = false"
                >
                  Chiudi
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-checkbox
            v-model="options.accepted_terms_media"
            class="mb-6"
            :disabled="withData.accepted_terms_media"
            :label="$gettext('Accettato i termini foto/video')"
            :messages="[
              dateIfAccepted(
                withData.accepted_terms_media,
                withData.accepted_terms_media_date
              ),
            ]"
          ></v-checkbox>
        </v-col>
      </v-row>

      <form-actions :loading="loading" @undo="reset" @submit="submit" />
    </v-form>
  </div>
</template>

<script>
import { cloneDeep, pick } from "@/lodash"

export default {
  props: {
    withData: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      options: {},
      dialog0: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
    }
  },
  watch: {
    withData: {
      handler: "reset",
      deep: true,
    },
  },
  methods: {
    reset() {
      this.options = cloneDeep(this.withData)
    },
    submit() {
      this.$emit(
        "submit",
        pick(this.options, [
          "accepted_terms_hospitality",
          "accepted_terms_media",
          "accepted_terms_performance",
          "accepted_terms_privacy",
          "availability_preferences",
        ])
      )
    },
    dateIfAccepted(acceptedTerms, date) {
      return acceptedTerms
        ? this.$formatDate(this.$parseDate(date), "d MMMM y")
        : ""
    },
  },
}
</script>
